const etcState = {
  breadCrumbList:["HOME"],
  selectKeys: [null],
  openKeys: [null],
  menuGroupList:[],
  menuList:[],
  allMenuGroup:[],
  allMenu:[],
  assignedMenu:[]
}

export default etcState